//PVQ Dropdown values
export const educationSchoolTypes = [
  'Vocational/Technical/Trade School',
  'College/University/Military Academy',
  'High School',
  'Other',
];

//PVQ Dropdown values
export const educationLearningExperienceOptions = [
  'In-person',
  'Not in-person (for example, correspondence, online, extension, other similar distance learning education)',
  'Combination of in-person and not in-person',
];

//PVQ Dropdown values
export const degreeTypes = [
  'Associate\'s degree',
  'Bachelor\'s degree',
  'Master\'s degree',
  'Doctoral degree',
  'Professional degree (for example, MD, JD, DVM)', 
  'High School diploma',
  'Other',
];

//PVQ Dropdown values
export const educationVerifierTypes = [
  'Instructor',
  'Counselor',
  'Friend',
  'Schoolmate',
  'Other',
];
